import { Blue } from 'core/buttons/blue'
import { Download } from 'core/buttons/download'

export const Buttons = { Blue, Download }
